package br.com.texeratx.boardgametimeapp.ui.screens.dashboard

import br.com.texeratx.boardgametimeapp.data.repository.DashboardRepository
import br.com.texeratx.boardgametimeapp.ui.screens.dashboard.model.*
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

class DashboardViewModel(
    private val repository: DashboardRepository
) : ScreenModel {

    val state = MutableStateFlow(DashboardUiState())

    fun loadDashboard() {
        screenModelScope.launch {
            state.value = state.value.copy(isLoading = true, error = null)

            val result = repository.getDashboard()

            result.fold(
                onSuccess = { dto ->

                    state.value = state.value.copy(
                        isLoading = false,
                        topPlayers = dto.topPlayers.map {
                            DashboardPlayerUI(
                                playerId = it.playerId,
                                name = it.name,
                                nickname = it.nickname,
                                imageUrl = it.imageUrl,
                                wins = it.wins,
                                seconds = it.seconds,
                                participations = it.participations,
                                winRate = it.winRate,
                                secondRate = it.secondRate
                            )
                        },
                        topGames = dto.topGames.map {
                            DashboardGameUI(
                                gameId = it.gameId,
                                name = it.name,
                                imageUrl = it.imageUrl,
                                count = it.count
                            )
                        },
                        lastMatches = dto.lastMatches.map {
                            LastMatchesUI(
                                matchId = it.matchId,
                                gameName = it.gameName,
                                gameImageUrl = it.gameImageUrl,
                                date = it.date,
                                duration = it.duration,
                                players = it.players
                            )
                        },
                        currentMonthMatches = dto.currentMonthMatches,
                        currentMonthMinutes = dto.currentMonthMinutes
                    )
                },

                onFailure = { e ->
                    state.value = state.value.copy(
                        isLoading = false,
                        error = e.message ?: "Erro desconhecido"
                    )
                }
            )
        }
    }
}
